import { useQuery } from "@tanstack/react-query"
import { getAutoCompleteClient } from "@/entities/search/api/search.client"
import { AutoCompleteRequest, AutoCompleteResponse } from "@/shared/types/type/search"
import { ApiResponse } from "@/shared/types/interface/api"

export const useQueryAutoComplete = <TData>(params: AutoCompleteRequest) => {
  return useQuery<ApiResponse<AutoCompleteResponse[]>, Error, TData>({
    select: (data) => data.result as TData,
    queryKey: ["autoComplete", params.query, params.size],
    queryFn: () => getAutoCompleteClient(params),
    enabled: (params.query?.length ?? 0) >= 2 && /^[가-힣]+$/.test(params.query || ""),
  })
}
